import { createSlice } from '@reduxjs/toolkit';
import { getFeatureMatrix } from './featureMatrixAction';

const featureMatrixSlice = createSlice({
  name: 'featureMatrix',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureMatrix.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFeatureMatrix.fulfilled, (state, { payload }) => {
      state.response = payload;
      state.loading = false;
    });
    builder.addCase(getFeatureMatrix.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export { featureMatrixSlice };
